import script from "./ListPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./ListPagination.vue?vue&type=script&setup=true&lang=js"

import "./ListPagination.vue?vue&type=style&index=0&id=c76934e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c76934e8"]])

export default __exports__